/* global React, ReactDOM, Nav, Hero, Problem, Directions, Case, Calculator, Pricing, Comparison, Faq, CtaBlock, Footer, CheckoutModal */
const { useState: useStateApp, useEffect: useEffectApp } = React;

function App() {
  // Generation counter re-renders the entire subtree on locale change.
  // Every component reads strings fresh from window.i18n.t(...) on each render.
  const [, setGen] = useStateApp(0);
  useEffectApp(() => {
    const onChange = () => setGen((g) => g + 1);
    window.addEventListener("i18n:change", onChange);
    return () => window.removeEventListener("i18n:change", onChange);
  }, []);

  // Mount-ready flag for Playwright e2e specs.
  //
  // The landing transpiles JSX in the browser via Babel-Standalone, which
  // means there's a small window between `DOMContentLoaded` and the first
  // paint where `document.querySelector("nav")` returns null. Without a
  // mount-ready signal the e2e suite races the transpiler and goes flaky.
  //
  // This flag is awaited by `tests/e2e/helpers/i18n.ts#gotoLocale`. Setting
  // it inside `requestAnimationFrame` guarantees we run after the first
  // paint, which is the actual gate the specs care about.
  //
  // Phase 2.6 of `.ai-factory/plans/set-up-testing-and-ci-cd-pipeline.md`.
  useEffectApp(() => {
    const raf =
      typeof window.requestAnimationFrame === "function"
        ? window.requestAnimationFrame
        : (cb) => setTimeout(cb, 0);
    raf(() => {
      window.__APP_READY__ = true;
      // Debug breadcrumb for Playwright e2e specs (Phase 2.6 of testing plan).
      /* eslint-disable no-console */
      if (typeof console !== "undefined" && typeof console.debug === "function") {
        console.debug("[app] ready");
      }
      /* eslint-enable no-console */
    });
  }, []);

  return (
    <>
      <Nav />
      <main>
        <Hero />
        <Problem />
        <Directions />
        <Case />
        <Calculator />
        <Pricing />
        <Comparison />
        <Faq />
        <CtaBlock />
      </main>
      <Footer />
      {/* HB-PAY: global mount for the checkout modal; window.CheckoutModal.open() drives it */}
      <CheckoutModal />
    </>
  );
}

ReactDOM.createRoot(document.getElementById("root")).render(<App />);
